import { Maybe } from './globalTypes'

import {
  CardTypeSectionFragment,
  isCardTypeSectionFragment,
} from './CardTypeSectionFragment'

import bentoSectionFragmentRawString from '../../fragments/BentoSectionFragment.graphql'

export const bentoSectionFragmentString = bentoSectionFragmentRawString

export type BentoSectionFragment = {
  __typename: 'ComponentSectionsBentoSections'
  id: string
  bentoSection: Maybe<Maybe<CardTypeSectionFragment>[]>
}

export const isBentoSectionFragment = (
  fragment: any,
): fragment is BentoSectionFragment =>
  fragment &&
  fragment.__typename === 'ComponentSectionsBentoSections' &&
  typeof fragment.id === 'string' &&
  (fragment.bentoSection === null ||
    (Array.isArray(fragment.bentoSection) &&
      fragment.bentoSection
        .slice(0, 5)
        .reduce(
          (accum: any, next: any) =>
            accum &&
            (next === null || (isCardTypeSectionFragment(next) as boolean)),
          true,
        )))
